var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { useEffect, useRef, useState } from 'react';
import { useSiteContext } from '../../SiteContext';
export function useSubscribeComponentChanges(plugin, _a) {
    var { id, children, component: initialComponent } = _a, props = __rest(_a, ["id", "children", "component"]);
    const { subscribe, unsubscribe } = useSiteContext();
    // Set up the component state
    const [component, setComponent] = useState(initialComponent || {
        id: id,
        name: plugin.name,
        type: plugin.type,
        depth: 0,
        position: 0,
        props: Object.assign({}, props)
    });
    // Make a local reference to the component state
    const componentRef = useRef(component);
    // update component on initialComponent change
    useEffect(() => {
        if (initialComponent) {
            componentRef.current = initialComponent;
            initialComponent && setComponent(initialComponent);
        }
    }, [initialComponent]);
    // Subscribe to any component changes coming from the component editor
    useEffect(() => {
        const handleSubscribe = (component) => {
            componentRef.current = component;
            setComponent(component);
        };
        const component = componentRef.current;
        subscribe(component, handleSubscribe);
        return () => unsubscribe(component, handleSubscribe);
    }, [subscribe, unsubscribe]);
    return component;
}
//# sourceMappingURL=useSubscribeComponentChanges.js.map